import { Component, OnInit, OnDestroy,ViewChild,ElementRef,AfterViewInit } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ShareService } from './../services/services';
import {Contact,ContactService } from './contact.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title,BrowserModule,DomSanitizer} from '@angular/platform-browser';
import { AlertService} from './../services/alert.service';
import { CopyWriteService} from './../services/copywrite.service';
import { MetaService } from 'ng2-meta';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  address: string;
  email: string;
  google_map_url:string;
  contactno: string;
    
}
@Component({
   // moduleId: module.id,
	//template: require('./contact.component.html'),
	
	
	templateUrl: './pg/contact/contact.component.html',	
})

export class ContactComponent implements OnInit {
	
	 loading = false;
	pagedata: PageData;
	public params;
	public apiData;
	public serviceData;
	public siteinfo;
	private _sub: Subscription;
	//ContactUsForm: ControlGroup;
	public googlemap;
	public metatitle;
    public metadescription;
    ContactUsForm: FormGroup;
    
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private metaService: MetaService,
	    private alertService: AlertService,
	    private copywriteservice:CopyWriteService,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private _sanitizer: DomSanitizer,
	    public fb: FormBuilder,    
	    private _pageService: ContactService) {		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  address:'',
                  google_map_url:'',
                  email:'',
                  contactno:''                 
				  	}				 
		 /*  this.ContactUsForm = this.fb.group({
			   email: ["", Validators.required],
			   name: ["", Validators.required]
			   });	*/
		   this.ContactUsForm = fb.group({
      'email': [
        '', // default value
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      'name': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
       'phone': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      'subject': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      'message': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ]


    });	
		   
		   	   
	    }

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh hhhnaga";
	   // alert("page");
	 // this.siteinfo=;
	  
     
     // this._title.setTitle('Contact Us');
    // this.siteinfo=this.shareService.getsiteinfo();    
      //console.log("Mydata->"+this.siteinfo.site_address);        
     // this._title.setTitle(this.siteinfo.meta_title);
      this.slimLoadingBarService.start(); 

      setTimeout(()=>{    //<<<---    using ()=> syntax
         
                
      this.siteinfo=this.shareService.getsiteinfo();    
      //console.log("Mydata->"+this.siteinfo.site_address);        
      this.pagedata.address=this.siteinfo.address;
      this.pagedata.email=this.siteinfo.email;
      this.pagedata.contactno=this.siteinfo.contactno;
      this.googlemap=this._sanitizer.bypassSecurityTrustUrl(this.siteinfo.google_map_url);
      this.metaService.setTitle('Contact Us');
	  this.metaService.setTag('description',this.siteinfo.meta_description);
	   let copywrite=this.shareService.getcopywrite();  
			      //console.log("Mydata->"+this.siteinfo.site_address);        
	   this.copywriteservice.copywritelogo(copywrite);
	   this.slimLoadingBarService.complete();
	  },1000);
	 	  
	 this._title.setTitle("Contact Us");
	 

		
	
		
	}
    ngAfterViewInit()
    {
       
	  
	 }
    ngOnDestroy() {
      // this._sub.unsubscribe();
    }
    
    ContactUsValidate(): boolean {

  if (this.ContactUsForm.valid) {
    return true;
  }
  let errorMsg = '';

  let field_name = this.ContactUsForm.controls['name'];
  if (!field_name.valid) {
    if (field_name.errors['required']) {
      errorMsg = 'Provide a Name please.<br />';
    }
  }

  let fieldemail = this.ContactUsForm.controls['email'];
  if (!fieldemail.valid) {
    if (fieldemail.errors['required']) {
      errorMsg = errorMsg+'Provide a Email please.<br />';
    }
  }
  let fieldsubject = this.ContactUsForm.controls['subject'];
  if (!fieldsubject.valid) {
    if (fieldsubject.errors['required']) {
      errorMsg = errorMsg+'Provide a Subject please.<br />';
    }
  }
  let fieldmesage = this.ContactUsForm.controls['message'];
  if (!fieldmesage.valid) {
    if (fieldmesage.errors['required']) {
      errorMsg = errorMsg+'Provide a Message please.<br />';
    }
  }
 if(errorMsg!="")
 {
    //alert(errorMsg);
    this.alertService.error(errorMsg);
    
  return false;
  }
  else
  {
    return true;
  }
}
    doContactUs(event) {
       
  
     if (this.ContactUsValidate()) {
    
            let name = this.ContactUsForm.controls['name'].value;
			let phone = this.ContactUsForm.controls['phone'].value;
			let email = this.ContactUsForm.controls['email'].value;
			let subject = this.ContactUsForm.controls['subject'].value;
			let message = this.ContactUsForm.controls['message'].value;
			
			
            this.params = {
                 
                  name: name,
                  email: email,
                  phone: phone,
                  subject:subject,
                  message:message,
                };
               this._pageService.doContactUs(this.params).subscribe(
        data => {
            this.apiData = data;
             //loading.dismiss();
             
             if(data.status=='success')
             {
	              this.alertService.success(data.message);
	              this.reset();
	              
             }
             else
             {
	             this.alertService.error(data.message);
             }
           
            
        },
        err => console.error(err),
        () => console.log('services completed')
    );
               console.log(this.ContactUsForm.value);
               
               
              
    };
  }
  
   reset() {
     this.ContactUsForm.reset();
       }
     
     
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/contact/contact.component.ts